import { render, staticRenderFns } from "./BranchesSales.vue?vue&type=template&id=04a78d14"
import script from "./BranchesSales.vue?vue&type=script&lang=js"
export * from "./BranchesSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports